/* ===========================================================================
   AUTHOR PROFILE — behaviour. Source of truth:
   design-system/ui_kits/website/author-profile.html, the LAST <script>.
   Scoped to the document because each design section is its own theme section;
   guarded so it runs once even when several sections request it.
   =========================================================================== */
/* ══════════════════════════════════════════════════════════════════════
   AUTHOR PROFILE — vanilla port of the handoff's DCLogic class.
   Everything is scoped to .tws-ap; the locked chrome and footer are never
   touched. Mirrors the Liquid conditionals so the local preview behaves
   exactly as the Shopify template will.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  /* ⚠ On Shopify each design section is its own theme section, so the page
     carries NINE .tws-ap wrappers, not one. Querying the first wrapper would
     scope every lookup to the hero. Scope to the document instead — every
     class here is ap-* prefixed and belongs to this page only. */
  if (!document.querySelector('.tws-ap')) return;
  /* ⚠ And the section tag renders once PER SECTION, so this file can be
     requested several times. Run once. */
  if (window.__twsApInit) return;
  window.__twsApInit = 1;
  var root = document;
  var RM = matchMedia('(prefers-reduced-motion: reduce)');

  /* ── 1. page-turn book ─────────────────────────────────────────────
     Built from the real <img> list in .ap-bk-src, which stands alone if
     this script never runs. Two layouts:
       spread (>=760)  leaf j: front = img[2j], back = img[2j+1]  — a real
                       two-page book; the flipped leaf's BACK becomes the
                       left page, so every image is seen.
       single (<760)   leaf j: front = img[j]                     — one
                       image per turn, nothing skipped.
     Turning stops on the last uploaded image; there are no blank swipes. */
  function initBook() {
    var host = document.getElementById('apBook');
    var stage = document.getElementById('apStage');
    var lane = document.getElementById('apLeaves');
    var prev = document.getElementById('apPrev');
    var next = document.getElementById('apNext');
    var count = document.getElementById('apCount');
    if (!host || !stage || !lane) return;

    var src = Array.prototype.slice.call(host.querySelectorAll('.ap-bk-src img'));
    var N = src.length;
    if (!N) { var sec = host.closest('section'); if (sec) sec.style.display = 'none'; return null; }

    var pages = src.map(function (im) {
      return { src: im.currentSrc || im.src, alt: im.alt || '' };
    });

    /* Give the pane the pages' OWN aspect ratio. With a fixed 1/1.4 guess the
       paper never quite fills its box and the section colour shows through as
       a band at an edge — which is the "background at the bottom". Measured
       from the first page, once it has decoded. */
    var bkEl = document.getElementById('apBk');
    function setRatio() {
      var im = src[0];
      if (!im || !bkEl) return;
      /* ⚠ Read the width/height ATTRIBUTES, not naturalWidth. The source list
         is lazy-loaded and gets display:none the moment the book takes over,
         so those images may never decode — naturalWidth stays 0 and the load
         event never fires. The attributes are always there. */
      var w = parseFloat(im.getAttribute('width')) || im.naturalWidth;
      var h = parseFloat(im.getAttribute('height')) || im.naturalHeight;
      if (!w || !h) return;
      bkEl.style.setProperty('--pg', w + ' / ' + h);
    }
    setRatio();
    if (src[0]) src[0].addEventListener('load', setRatio, { once: true });

    var wide = matchMedia('(min-width:760px)');
    var mode, leaves, tMax, t = 0;

    function face(cls, page) {
      if (!page) return '<div class="' + cls + '"><span class="ap-leaf-img ap-leaf-blank"></span><span class="ap-leaf-shade" aria-hidden="true"></span></div>';
      return '<div class="' + cls + '"><span class="ap-leaf-img"><img src="' + page.src +
        '" alt="' + String(page.alt).replace(/"/g, '&quot;') + '" loading="lazy" decoding="async"></span>' +
        '<span class="ap-leaf-shade" aria-hidden="true"></span></div>';
    }

    function build(keepImg) {
      mode = wide.matches ? 'spread' : 'single';
      var html = '<span class="ap-bind" aria-hidden="true"></span>';
      var L, j;
      if (mode === 'spread') {
        L = Math.ceil(N / 2);
        for (j = 0; j < L; j++) {
          html += '<div class="ap-leaf" data-j="' + j + '">' +
            face('ap-leaf-f', pages[2 * j]) + face('ap-leaf-b', pages[2 * j + 1]) + '</div>';
        }
        tMax = Math.floor(N / 2);
      } else {
        L = N;
        for (j = 0; j < L; j++) {
          /* The BACK carries the next image, not blank paper. Past 90° the
             back is what faces the reader, so a blank one sweeps a cream
             page over the pane on every turn; carrying image j+1 means the
             turning page arrives showing exactly what leaf j+1 reveals
             underneath it, and the turn reads as seamless. */
          html += '<div class="ap-leaf" data-j="' + j + '">' +
            face('ap-leaf-f', pages[j]) + face('ap-leaf-b', pages[j + 1]) + '</div>';
        }
        tMax = N - 1;
      }
      lane.innerHTML = html;
      leaves = Array.prototype.slice.call(lane.querySelectorAll('.ap-leaf'));
      // keep the reader roughly where they were across a breakpoint change
      var idx = keepImg || 0;
      t = mode === 'spread' ? (idx <= 0 ? 0 : Math.min(tMax, Math.floor((idx + 1) / 2))) : Math.min(tMax, idx);
      paint();
    }

    function firstVisibleImg() {
      if (mode === 'spread') return t === 0 ? 0 : 2 * t - 1;
      return t;
    }

    function label() {
      if (mode === 'single') return (t + 1) + ' / ' + N;
      if (t === 0) return '1 / ' + N;
      var l = 2 * t, r = 2 * t + 1;
      return (r <= N ? l + '–' + r : '' + l) + ' / ' + N;
    }

    function paint(moved) {
      var total = leaves.length;
      leaves.forEach(function (el, i) {
        var flipped = i < t;
        el.classList.toggle('flipped', flipped);
        el.style.zIndex = flipped ? String(10 + i) : String(10 + (total - i));
        el.setAttribute('aria-hidden', i === t ? 'false' : 'true');
      });
      if (moved !== undefined && leaves[moved]) {
        // lift the leaf that is actually rotating above the rest of the stack
        leaves[moved].style.zIndex = '60';
      }
      if (count) count.textContent = label();
      if (prev) prev.disabled = t === 0;
      if (next) next.disabled = t >= tMax;
    }

    function go(dir) {
      /* Re-derive the layout before moving. Resize/matchMedia/ResizeObserver
         are all belt-and-braces above, but none of them is guaranteed to be
         delivered by every renderer — reading the state at the moment it
         matters is the one check that cannot be skipped. */
      syncMode();
      var target = t + dir;
      if (target < 0 || target > tMax) return;      // hard stop at the last image
      var moved = dir > 0 ? t : target;
      t = target;
      paint(moved);
    }
    function syncMode() {
      var want = wide.matches ? 'spread' : 'single';
      if (want !== mode) build(firstVisibleImg());
    }

    build(0);
    host.classList.add('ap-bk-live');

    if (next) next.addEventListener('click', function () { go(1); });
    if (prev) prev.addEventListener('click', function () { go(-1); });

    function onKey(e) {
      var r = stage.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    }
    addEventListener('keydown', onKey);

    var sx = 0, sy = 0, live = false;
    function down(e) {
      var p = e.touches ? e.touches[0] : e;
      sx = p.clientX; sy = p.clientY; live = true;
    }
    function up(e) {
      if (!live) return;
      live = false;
      var p = (e.changedTouches && e.changedTouches[0]) || e;
      var dx = p.clientX - sx, dy = p.clientY - sy;
      if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy)) {
        // a tap, not a swipe: on the spread, the left page goes back
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) {
          var box = stage.getBoundingClientRect();
          go(mode === 'spread' && p.clientX < box.left + box.width / 2 ? -1 : 1);
        }
        return;
      }
      go(dx < 0 ? 1 : -1);
    }
    stage.addEventListener('touchstart', down, { passive: true });
    stage.addEventListener('touchend', up, { passive: true });
    stage.addEventListener('mousedown', down);
    stage.addEventListener('mouseup', up);

    /* ⚠ DO NOT rely on the matchMedia 'change' event alone. Some renderers
       resize the viewport without dispatching it, and the book then stays in
       spread layout on a phone — where the left pane is display:none, so
       every even-numbered image (the leaf backs) becomes unreachable.
       Re-derive the mode on resize instead, and rebuild only on a real
       change so this stays free. */
    if (wide.addEventListener) wide.addEventListener('change', syncMode);
    else if (wide.addListener) wide.addListener(syncMode);
    var rq = false;
    var queueSync = function () {
      if (rq) return;
      rq = true;
      requestAnimationFrame(function () { rq = false; syncMode(); });
    };
    addEventListener('resize', queueSync, { passive: true });
    addEventListener('orientationchange', syncMode);
    /* the reliable one: watches the element itself, so it still fires where
       window resize / matchMedia events are not delivered at all. */
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(queueSync).observe(stage);

    /* ⚠ THE BOOK NO LONGER OPENS ITSELF (6 Aug, the user). It used to turn the
       first page on its own 700ms after scrolling into view. Removed on BOTH
       the author landing page and the featured-writing page — this file serves
       both — so the book now waits for the reader.
       The `.ap-bk-hint` line ("Swipe, tap or use your arrow keys") is what
       signals it is interactive, so nothing is lost by not demonstrating it. */
    return true;
  }

  /* ── 2. excerpt tabs ───────────────────────────────────────────────── */
  function initExcerpts() {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.ap-rr-tab'));
    var panes = Array.prototype.slice.call(root.querySelectorAll('.ap-rr-pane'));
    if (!tabs.length) return;
    function select(b) {
      var i = b.getAttribute('data-i');
      tabs.forEach(function (x) {
        var on = x === b;
        x.classList.toggle('on', on);
        x.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panes.forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-i') === i); });
    }
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () { select(b); });
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = tabs[(i + d + tabs.length) % tabs.length];
        n.focus(); select(n);
      });
    });
  }

  /* ── 3. video — click-to-play facade ───────────────────────────────
     No YouTube payload is fetched until the visitor asks for it, which is
     what keeps this section cheap on a phone. */
  function initVideo() {
    var box = document.getElementById('apVid');
    var btn = document.getElementById('apVidPlay');
    if (!box) return;
    var id = (box.getAttribute('data-yt') || '').trim();
    if (!id) { var s = box.closest('section'); if (s) s.style.display = 'none'; return; }
    if (!btn) return;
    btn.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      f.title = 'Video from the author';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      f.setAttribute('allowfullscreen', 'true');
      f.loading = 'lazy';
      box.innerHTML = '';
      box.appendChild(f);
    });
  }

  /* ── 4. optional fields — empty means invisible, never an empty gap ── */
  function initOptional() {
    // socials: drop the empty ones, drop the whole row if none survive
    var socs = Array.prototype.slice.call(root.querySelectorAll('[data-soc]'));
    var live = 0;
    socs.forEach(function (a) {
      var href = (a.getAttribute('href') || '').trim();
      if (!href || href === '#') { a.remove(); return; }
      live++;
    });
    var follow = document.getElementById('apFollow');
    if (follow && !live) follow.style.display = 'none';

    // excerpts: no panes with text means no section
    var panes = Array.prototype.slice.call(root.querySelectorAll('.ap-rr-pane'));
    var filled = panes.filter(function (p) { return p.textContent.trim().length; });
    var ex = document.getElementById('ap-excerpts');
    if (ex && !filled.length) ex.style.display = 'none';

    // who should read
    var wr = root.querySelectorAll('.ap-wr');
    var who = document.getElementById('ap-whofor');
    if (who && !wr.length) who.style.display = 'none';

    // if the carousel is gone, the buttons that jump to it must go too
    var look = document.getElementById('ap-look');
    if (!look || look.style.display === 'none' || !root.querySelectorAll('.ap-bk-src img').length) {
      Array.prototype.slice.call(root.querySelectorAll('a[href="#ap-look"]')).forEach(function (a) { a.remove(); });
    }
  }

  /* ── 4a. the 3D cover — trim the mockup's backdrop automatically.
     book_mockup holds a DIFFERENT KIND of render for every author: some are
     flat covers floating on grey/tan/mauve, some are already 3D hardbacks on
     white. Tilting the raw image gives a tilted slab with a small book on it.
     So the backdrop is measured and cropped at runtime: sample the four
     corners for the background colour, find the bounding box of everything
     that differs from it, and scale the image inside its frame so the frame
     IS the book. Full-bleed renders trim to ~0 and are unaffected.
     If anything fails (CORS, no canvas) the image is simply left alone. */
  function initCoverTrim() {
    var frame = root.querySelector('.ap-hb-front');
    var book = root.querySelector('.ap-hb');
    var img = frame && frame.querySelector('img');
    if (!frame || !img || !book) return;
    /* ⚠ DO NOT GUESS AT A COVER WE WERE GIVEN PROPERLY.
       These 80-odd lines exist only for the legacy `book_mockup` — a PHOTO of
       a book on a coloured backdrop, which has to be detected and cropped at
       runtime. Every author now has a real `book_cover`, and running a
       corner-sampling auto-crop over artwork that is already correct can only
       make it worse. The Liquid marks those with data-real-cover, and this
       returns immediately. One code path per data state; nothing to debug. */
    if (book.getAttribute('data-real-cover') === '1') return;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onerror = function () {};
    probe.onload = function () {
      try {
        var S = 140;
        var c = document.createElement('canvas');
        c.width = S;
        c.height = Math.max(1, Math.round(S * probe.naturalHeight / probe.naturalWidth));
        var ctx = c.getContext('2d');
        ctx.drawImage(probe, 0, 0, c.width, c.height);
        var d = ctx.getImageData(0, 0, c.width, c.height).data;
        var at = function (i, j) { var o = (j * c.width + i) * 4; return [d[o], d[o + 1], d[o + 2]]; };
        var corners = [at(0, 0), at(c.width - 1, 0), at(0, c.height - 1), at(c.width - 1, c.height - 1)];
        var bg = [0, 1, 2].map(function (k) {
          return Math.round(corners.reduce(function (s, p) { return s + p[k]; }, 0) / 4);
        });
        // if the corners disagree wildly the image is not on a flat backdrop
        var spread = Math.max.apply(null, corners.map(function (p) {
          return Math.max.apply(null, p.map(function (v, k) { return Math.abs(v - bg[k]); }));
        }));
        if (spread > 42) return;
        var x0 = c.width, y0 = c.height, x1 = -1, y1 = -1;
        for (var jj = 0; jj < c.height; jj++) {
          for (var ii = 0; ii < c.width; ii++) {
            var p = at(ii, jj);
            /* 70, not a low number: the mockups carry a soft baked drop
               shadow that a low threshold counts as content, leaving a grey
               fringe. Hard-edged full-bleed renders are insensitive to it. */
            if (Math.max(Math.abs(p[0] - bg[0]), Math.abs(p[1] - bg[1]), Math.abs(p[2] - bg[2])) > 70) {
              if (ii < x0) x0 = ii; if (ii > x1) x1 = ii;
              if (jj < y0) y0 = jj; if (jj > y1) y1 = jj;
            }
          }
        }
        if (x1 < x0 || y1 < y0) return;
        var l = x0 / c.width, t = y0 / c.height;
        var kw = (x1 + 1 - x0) / c.width, kh = (y1 + 1 - y0) / c.height;
        if (kw > 0.97 && kh > 0.97) return;            // nothing worth trimming
        if (kw < 0.12 || kh < 0.12) return;            // implausible, leave alone
        frame.style.aspectRatio = (probe.naturalWidth * kw) + ' / ' + (probe.naturalHeight * kh);
        frame.style.overflow = 'hidden';
        img.style.width = (100 / kw) + '%';
        img.style.height = (100 / kh) + '%';
        img.style.maxWidth = 'none';
        img.style.objectFit = 'fill';
        img.style.marginLeft = (-l / kw * 100) + '%';
        img.style.marginTop = (-t / kh * 100) + '%';
        frame.setAttribute('data-trimmed', '1');

        /* Give the spine the cover's own binding-edge colour, so the board
           and the spine read as one object instead of a photo stuck to a
           grey slab. Sampled from the left 6% of the TRIMMED cover, with the
           lightest and darkest pixels dropped so a white margin or a black
           rule can't drag the average. */
        var sx0 = x0, sx1 = Math.max(x0, Math.round(x0 + (x1 - x0) * 0.06));
        var vals = [];
        for (var sj = y0; sj <= y1; sj++) {
          for (var si = sx0; si <= sx1; si++) {
            var q = at(si, sj);
            vals.push([q, 0.2126 * q[0] + 0.7152 * q[1] + 0.0722 * q[2]]);
          }
        }
        if (vals.length > 8) {
          vals.sort(function (m, n) { return m[1] - n[1]; });
          var lo = Math.floor(vals.length * 0.15), hi = Math.ceil(vals.length * 0.85);
          var mid = vals.slice(lo, hi);
          var acc = [0, 1, 2].map(function (k) {
            return Math.round(mid.reduce(function (sum, v) { return sum + v[0][k]; }, 0) / mid.length);
          });
          // a spine is never brighter than its board — pull it down a little
          acc = acc.map(function (v) { return Math.max(12, Math.round(v * 0.82)); });
          book.style.setProperty('--spine', 'rgb(' + acc.join(',') + ')');
        }
      } catch (e) { /* tainted canvas or no 2d context — leave the image as-is */ }
    };
    probe.src = img.currentSrc || img.src;
  }

  /* ── 4a2. the hardcover turns once when it comes into view, then stops.
     No looping animation — the book settles square to the reader and stays
     there. Under reduced motion it is simply already settled. */
  function initCoverTurn() {
    var book = root.querySelector('.ap-hb');
    if (!book) return;
    var open = function () { book.classList.add('is-open'); };
    if (RM.matches || typeof IntersectionObserver === 'undefined') { open(); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        setTimeout(open, 180);
      });
    }, { threshold: 0.35 });
    io.observe(book);

    /* ⚠ The observer must not be the only route — the same rule as the scroll
       reveals. A one-shot timer is NOT enough either: it only catches the book
       if it happens to be near the fold when the timer fires, and on a desktop
       layout the cover sits below it, so the book stayed parked at its start
       angle forever. Sweep on scroll instead, and stop as soon as it opens. */
    var sweep = function () {
      if (book.classList.contains('is-open')) { stop(); return; }
      var vh = innerHeight || document.documentElement.clientHeight || 800;
      var r = book.getBoundingClientRect();
      if (r.top < vh * 0.85 && r.bottom > 0) { open(); stop(); }
    };
    var queued = false;
    var onScroll = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sweep(); });
    };
    var timer = setInterval(sweep, 300);
    function stop() {
      clearInterval(timer);
      removeEventListener('scroll', onScroll);
      document.removeEventListener('scroll', onScroll, true);
    }
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    sweep();
  }

  /* ── 4b. the book intro is long; on phones it clamps behind Read more.
     The clamp class is added HERE, not in the markup, so that a page whose
     script never runs shows the whole intro rather than eight cut-off lines
     with no way to open them. */
  function initBookClamp() {
    var box = root.querySelector('.ap-book-x');
    var txt = root.querySelector('.ap-book-txt');
    if (!box || !txt) return;
    var mq = matchMedia('(max-width:759px)');
    var btn = null;
    var apply = function () {
      if (!mq.matches) { if (btn) btn.hidden = true; box.classList.remove('ap-clamped'); return; }
      box.classList.add('ap-clamped');
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ap-book-more';
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-controls', 'apBookText');
        btn.textContent = 'Read more';
        box.id = 'apBookText';
        box.parentNode.insertBefore(btn, box.nextSibling);
        btn.addEventListener('click', function () {
          var open = box.classList.toggle('ap-clamped') === false;
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.textContent = open ? 'Read less' : 'Read more';
        });
      }
      btn.hidden = false;
    };
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
    addEventListener('resize', apply, { passive: true });
  }

  /* ── 5. bare URLs in the bio become real links ──────────────────────── */
  function linkifyBio() {
    var ps = Array.prototype.slice.call(root.querySelectorAll('.ap-about-body > p'));
    ps.forEach(function (p) {
      if (p.querySelector('a')) return;
      if (!/https?:\/\//.test(p.textContent)) return;
      p.innerHTML = p.innerHTML.replace(/(https?:\/\/[^\s<)]+[^\s<).,])/g,
        '<a href="$1" rel="noopener nofollow" target="_blank">$1</a>');
    });
  }

  /* ── 6. entrances ──────────────────────────────────────────────────
     `rise`/`riseS` start at opacity:0 and `both` holds that start frame
     until the animation actually runs — so a frozen or throttled renderer
     leaves the element invisible forever. Every reveal therefore clears
     its own animation once it can only have finished, AND an
     IntersectionObserver is never the only route back. */
  var revealPending = [];
  function revealShow(el) {
    var kind = el.getAttribute('data-rv') || 'rise';
    var d = parseInt(el.getAttribute('data-rv-d') || '0', 10);
    el.style.animation = kind + ' .78s cubic-bezier(.22,.7,.25,1) ' + d + 'ms both';
    el.style.opacity = '';
    setTimeout(function () { el.style.animation = ''; }, 900 + d);
  }
  function initReveal() {
    if (RM.matches) return;
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-rv]'));
    if (!els.length || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        revealShow(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top > innerHeight * 0.88) {
        el.style.opacity = '0';
        io.observe(el);
        revealPending.push(el);
      }
    });

    /* the backstop. ⚠ NEVER TRUST innerHeight TO BE SANE — an embedded or
       backgrounded renderer can report 0, which makes `top < vh * 0.94`
       unsatisfiable and strands everything the observer also missed. If the
       viewport height is unusable, reveal rather than gamble. */
    var sweep = function () {
      var vh = innerHeight || document.documentElement.clientHeight || 0;
      for (var i = revealPending.length - 1; i >= 0; i--) {
        var el = revealPending[i];
        if (el.style.opacity !== '0') { revealPending.splice(i, 1); continue; }
        if (!vh || el.getBoundingClientRect().top < vh * 0.94) {
          revealShow(el);
          revealPending.splice(i, 1);
        }
      }
    };
    var queued = false;
    var onScroll = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sweep(); });
    };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    setInterval(sweep, 300);
    sweep();
  }

  function initRules() {
    var rules = Array.prototype.slice.call(root.querySelectorAll('.ap-rule'));
    if (!rules.length || typeof IntersectionObserver === 'undefined') return;
    if (RM.matches) { rules.forEach(function (r) { r.style.transform = 'scaleX(1)'; }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.animation = 'ruleIn .9s cubic-bezier(.22,.7,.25,1) both';
        io.unobserve(e.target);
      });
    }, { threshold: 0.3 });
    rules.forEach(function (r) { io.observe(r); });
  }

  function splitWords() {
    var heads = Array.prototype.slice.call(root.querySelectorAll('h1, section h2'));
    if (RM.matches) return;
    function wrap(el) {
      Array.prototype.slice.call(el.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          if (!n.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var s = document.createElement('span');
            s.className = 'sw';
            var i = document.createElement('i');
            i.textContent = p;
            s.appendChild(i);
            frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.classList.contains('sw') && n.tagName !== 'svg' && n.tagName !== 'BUTTON' && n.tagName !== 'A') {
          wrap(n);
        }
      });
    }
    heads.forEach(function (h) {
      if (h.getAttribute('data-split')) return;
      h.setAttribute('data-split', '1');
      wrap(h);
      var words = h.querySelectorAll('.sw');
      function fire() {
        words.forEach(function (w, i) {
          w.classList.add('on');
          if (w.firstChild) w.firstChild.style.animationDelay = (i * 52) + 'ms';
        });
      }
      if (h.getBoundingClientRect().top < innerHeight * 0.9 || typeof IntersectionObserver === 'undefined') { fire(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { fire(); io.disconnect(); } });
      }, { threshold: 0.15 });
      io.observe(h);
    });
  }

  /* ── 7. LOCAL PREVIEW ONLY — removed before the Shopify push ───────── */
  function initDev() {
    var t = document.getElementById('apDevT'), p = document.getElementById('apDevP');
    if (!t || !p) return;
    t.addEventListener('click', function () {
      var open = p.hasAttribute('hidden');
      if (open) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    p.addEventListener('change', function (e) {
      var cb = e.target;
      if (!cb.matches('input[data-sec]')) return;
      var key = cb.getAttribute('data-sec');
      if (key === '__soc') {
        var f = document.getElementById('apFollow');
        if (f) f.style.display = cb.checked ? '' : 'none';
        return;
      }
      var sec = document.getElementById(key);
      if (sec) sec.style.display = cb.checked ? '' : 'none';
      if (key === 'ap-look') {
        Array.prototype.slice.call(root.querySelectorAll('a[href="#ap-look"]')).forEach(function (a) {
          a.style.display = cb.checked ? '' : 'none';
        });
      }
    });
  }

  function boot() {
    initOptional();
    initCoverTrim();
    initCoverTurn();
    initBookClamp();
    linkifyBio();
    initBook();
    initExcerpts();
    initVideo();
    splitWords();
    initReveal();
    initRules();
    initDev();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
